import React from 'react';
import { Link } from 'react-router-dom';
import { motion, useReducedMotion } from 'framer-motion';
import './Home.css';

const Home = () => {
    const reducedMotion = useReducedMotion();
    return (
        <motion.div
            className="home"
            initial={reducedMotion ? false : { opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: reducedMotion ? 0 : 0.5, ease: 'easeInOut' }}
        >
            {/* Hero - Full viewport gateway */}
            <section className="home-hero">
                <div className="home-hero-bg">
                    <img src="/hero-image.jpg" alt="" className="home-hero-bg-img" />
                    <div className="home-hero-bg-overlay"></div>
                </div>
                <div className="container home-hero-content">
                    <div className="home-hero-text">
                        <span className="label"><span className="brand-name">BAi Systems</span></span>
                        <h1>Technology that disappears into architecture.<span className="tm">™</span></h1>
                        <p className="home-tagline">
                            We design and engineer building systems as one coordinated whole,
                            with clear drawings, considered details and a single design authority.
                        </p>
                    </div>

                    {/* Four clear paths */}
                    <div className="home-paths">
                        <Link to="/builders" className="path-card">
                            <span className="path-label">I'm a</span>
                            <h3>Builder</h3>
                            <p>Clear scope. Coordinated trades. Fewer callbacks.</p>
                            <span className="path-arrow">→</span>
                        </Link>

                        <Link to="/architects" className="path-card">
                            <span className="path-label">I'm an</span>
                            <h3>Architect</h3>
                            <p>Design integrity preserved. Documentation included.</p>
                            <span className="path-arrow">→</span>
                        </Link>

                        <Link to="/homeowners" className="path-card">
                            <span className="path-label">I'm a</span>
                            <h3>Homeowner</h3>
                            <p>Your home already knows what you need.</p>
                            <span className="path-arrow">→</span>
                        </Link>

                        <Link to="/partners" className="path-card">
                            <span className="path-label">I'm an</span>
                            <h3>Integrator</h3>
                            <p>Expand capability without expanding headcount.</p>
                            <span className="path-arrow">→</span>
                        </Link>
                    </div>
                </div>

                <div className="home-scroll-hint">
                    <span>Scroll</span>
                    <div className="scroll-line"></div>
                </div>
            </section>

            {/* Brief credibility section */}
            <section className="home-credibility">
                <div className="container">
                    <div className="credibility-content">
                        <h2>Engineering-first automation for projects that demand precision.</h2>
                        <p>
                            We bring commercial-grade discipline to building automation: system design,
                            documentation, trade coordination and commissioning. Vetted field partners
                            handle installation, with every trade working from a coordinated plan.
                        </p>
                        <Link to="/about" className="btn btn-secondary">
                            Learn our approach
                        </Link>
                    </div>

                    <div className="credibility-stats">
                        <div className="stat">
                            <span className="stat-number">13+</span>
                            <span className="stat-label">Founder’s experience</span>
                        </div>
                        <div className="stat">
                            <span className="stat-number">Design</span>
                            <span className="stat-label">One authority across trades</span>
                        </div>
                        <div className="stat">
                            <span className="stat-number">Build</span>
                            <span className="stat-label">Vetted installation partners</span>
                        </div>
                        <div className="stat">
                            <span className="stat-number">Handoff</span>
                            <span className="stat-label">Drawings, records and training</span>
                        </div>
                    </div>
                </div>
            </section>

            {/* Simple CTA */}
            <section className="home-cta">
                <div className="container">
                    <h2>Ready to start a conversation?</h2>
                    <p>Whether you're planning a new build or upgrading an existing property.</p>
                    <Link to="/contact" className="btn btn-primary">
                        Get in touch
                    </Link>
                </div>
            </section>
        </motion.div>
    );
};

export default Home;
